import { render, staticRenderFns } from "./bnps_edit_project.vue?vue&type=template&id=846b5622&"
import script from "./bnps_edit_project.vue?vue&type=script&lang=js&"
export * from "./bnps_edit_project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports